<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 8rem">
    <!-- Body -->

    <v-layout class="justify-center mt-4 px-4">
      <v-flex xs12>
        <v-layout class="mt-4" :column="$vuetify.breakpoint.smAndDown">
          <!-- column left -->
          <v-flex class="pr-0 pb-6 xs7">
            <!-- NEW PORTFOLIO -->
            <v-layout class="d-flex align-center">
              <v-flex class=" font-weight-bold" style="font-size: 30px">
                <span>NEW PORTFOLIO</span>
              </v-flex>
              <v-flex
                shrink
                class="text-end"
                style="color: #FD5246;"
                @click="onclickCategory('new')"
              >
                <span v-if="switchLanguage === 'th'" style="cursor: pointer;"
                  >เพิ่มเติม
                  <v-icon color="#FD5246">keyboard_arrow_right</v-icon></span
                >
                <span v-if="switchLanguage === 'en'" style="cursor: pointer;"
                  >More
                  <v-icon color="#FD5246">keyboard_arrow_right</v-icon></span
                >
              </v-flex>
            </v-layout>
            <div>
              <span style="color: #000;">{{ $t("portfolio") }}</span>
            </div>

            <!-- Article -->
            <v-card flat color="#F8F8F8">
              <loading
                color="#FD5246"
                :active.sync="isLoadingNew"
                :can-cancel="false"
                :is-full-page="false"
              ></loading>

              <v-layout class="justify-space-around" wrap>
                <v-flex
                  class="lg4 pr-lg-4 my-lg-6 md4 pr-md-2 my-md-6 sm4 pr-sm-4 my-sm-6 xs12 my-2"
                  v-for="(newPort, index) in newPorts"
                  :key="index"
                  @click="viewPortDetail(newPort)"
                >
                  <card-content
                    font-lg="14"
                    font-md="10"
                    font-sm="14"
                    height="100%"
                    :image-cover="newPort.cover_img_path"
                    :title="newPort.project_title"
                    :by="newPort.profile"
                    :image-profile="
                      newPort.profile
                        ? checkImage(newPort.profile.mem_info)
                        : ''
                    "
                  ></card-content>
                </v-flex>
              </v-layout>
            </v-card>

            <v-layout class="justify-space-around my-4">
              <v-flex class="xs12">
                <v-divider style="border: 0.5px solid #C4C4C4;"></v-divider>
              </v-flex>
            </v-layout>

            <!-- COLLECTION -->
            <v-layout class="mt-8">
              <v-flex class=" font-weight-bold" style="font-size: 30px">
                <span>COLLECTION</span>
              </v-flex>
              <v-flex
                shrink
                class="d-flex align-center justify-end"
                style="color: #FD5246;"
                @click="onClickMoreCollection"
              >
                <span v-if="switchLanguage === 'th'" style="cursor: pointer;"
                  >เพิ่มเติม
                  <v-icon color="#FD5246">keyboard_arrow_right</v-icon></span
                >
                <span v-if="switchLanguage === 'en'" style="cursor: pointer;"
                  >More
                  <v-icon color="#FD5246">keyboard_arrow_right</v-icon></span
                >
              </v-flex>
            </v-layout>
            <div>
              <span style="color: #000;">{{ $t("collection-portfolio") }}</span>
            </div>

            <!-- Article -->
            <v-card flat color="#F8F8F8">
              <loading
                color="#FD5246"
                :active.sync="isLoadingCreator"
                :can-cancel="false"
                :is-full-page="false"
              ></loading>

              <v-layout wrap mt-8>
                <v-flex
                  lg6
                  md6
                  sm12
                  xs12
                  v-for="(collection, i) in creator"
                  :key="i"
                >
                  <v-hover
                    v-slot:default="{ hover }"
                    open-delay="50"
                    style="cursor: pointer"
                  >
                    <v-card
                      flat
                      width="auto"
                      height="auto"
                      class="mx-2 mb-4 mx-md-2"
                      @click="getCollectionPortfolio(collection)"
                    >
                      <v-layout style="max-height: 450px;">
                        <v-flex>
                          <v-img
                            :aspect-ratio="20 / 10"
                            height="100%"
                            width="100%"
                            style="border-top-left-radius: 5px;border-top-right-radius: 5px;"
                            :src="
                              collection.cover_path !== null
                                ? url +
                                  imgPath +
                                  'images_collection/' +
                                  collection.cover_path
                                : require('../../assets/tcdc-color.png')
                            "
                            :contain="
                              collection.cover_path !== null ? false : true
                            "
                          >
                            <v-expand-transition>
                              <div
                                v-if="hover"
                                class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                                style="height: 100%;"
                              >
                                <span
                                  style="font-size: 16px;font-weight: bold"
                                  class="text-uppercase"
                                  >see detail</span
                                >
                              </div>
                            </v-expand-transition>
                          </v-img>
                        </v-flex>
                      </v-layout>
                      <v-layout style="background-color: #FFFFFF">
                        <v-flex class="pa-3">
                          <div
                            style="font-size: 14px"
                            class="one-line"
                            :style="{
                              'font-size': $vuetify.breakpoint.lgAndUp
                                ? '14px'
                                : '' || $vuetify.breakpoint.mdAndUp
                                ? '14px'
                                : '' || $vuetify.breakpoint.smAndUp
                                ? '14px'
                                : '' || $vuetify.breakpoint.smAndDown
                                ? '12px'
                                : '',
                            }"
                          >
                            {{ collection.collection_name_th }}
                          </div>
                          <div
                            :style="{
                              'font-size': $vuetify.breakpoint.lgAndUp
                                ? '11px'
                                : '' || $vuetify.breakpoint.mdAndUp
                                ? '11px'
                                : '' || $vuetify.breakpoint.smAndUp
                                ? '11px'
                                : '' || $vuetify.breakpoint.smAndDown
                                ? '12px'
                                : '',
                            }"
                            style="color: #C4C4C4;font-size: 14px"
                          >
                            {{ $t("update-date") }} :
                            {{
                              switchLanguage === "th"
                                ? collection.date_th
                                : collection.date_en
                            }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-divider
            v-if="$vuetify.breakpoint.mdAndUp"
            vertical
            class="mb-6 ml-lg-4 mr-lg-8 ml-md-4 mr-md-6"
            style="border: 0.5px solid #C4C4C4;"
          ></v-divider>
          <v-divider
            v-else
            class="mb-12 mt-4"
            style="border: 0.5px solid #C4C4C4;"
          ></v-divider>

          <!-- column right -->
          <v-flex class="xs5 pb-6">
            <!-- Highlight -->
            <v-layout class="d-flex align-center">
              <v-flex class="font-weight-bold" style="font-size: 30px">
                <span>HIGHLIGHT</span>
              </v-flex>
            </v-layout>
            <div>
              <span style="color: #000;">{{ $t("creator-portfolio") }}</span>
            </div>

            <!-- Image -->
            <div style="cursor: pointer" v-show="highlight">
              <v-card flat color="#F8F8F8">
                <loading
                  color="#FD5246"
                  :active.sync="isLoadingHighlight"
                  :can-cancel="false"
                  :is-full-page="false"
                ></loading>
                <v-layout wrap mt-6>
                  <v-flex xs12>
                    <v-hover
                      v-slot:default="{ hover }"
                      open-delay="50"
                      style="cursor: pointer"
                    >
                      <v-card
                        flat
                        width="auto"
                        height="auto"
                        @click="getCollectionPortfolio(highlight)"
                      >
                        <v-layout class="" style=" max-height: 296px;">
                          <v-flex xs12>
                            <v-img
                              :aspect-ratio="21 / 9"
                              height="100%"
                              width="100%"
                              style="border-top-left-radius: 5px;border-top-right-radius: 5px;"
                              :src="
                                highlight.cover_path !== null
                                  ? url +
                                    imgPath +
                                    'images_collection/' +
                                    highlight.cover_path
                                  : require('../../assets/tcdc-color.png')
                              "
                              :contain="
                                highlight.cover_path !== null ? false : true
                              "
                            >
                              <v-expand-transition>
                                <div
                                  v-if="hover"
                                  class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                                  style="height: 100%;"
                                >
                                  <span
                                    style="font-size: 16px;font-weight: bold"
                                    class="text-uppercase"
                                    >see detail</span
                                  >
                                </div>
                              </v-expand-transition>
                            </v-img>
                          </v-flex>
                        </v-layout>
                        <v-layout style="background-color: #FFFFFF">
                          <v-flex class="pa-3">
                            <div
                              style="font-size: 14px"
                              class="one-line"
                              :style="{
                                'font-size': $vuetify.breakpoint.lgAndUp
                                  ? '14px'
                                  : '' || $vuetify.breakpoint.mdAndUp
                                  ? '14px'
                                  : '' || $vuetify.breakpoint.smAndUp
                                  ? '14px'
                                  : '' || $vuetify.breakpoint.smAndDown
                                  ? '12px'
                                  : '',
                              }"
                            >
                              {{ highlight.collection_name_th }}
                            </div>
                            <div
                              :style="{
                                'font-size': $vuetify.breakpoint.lgAndUp
                                  ? '11px'
                                  : '' || $vuetify.breakpoint.mdAndUp
                                  ? '11px'
                                  : '' || $vuetify.breakpoint.smAndUp
                                  ? '11px'
                                  : '' || $vuetify.breakpoint.smAndDown
                                  ? '12px'
                                  : '',
                              }"
                              style="color: #C4C4C4;font-size: 14px"
                            >
                              {{ $t("update-date") }} :
                              {{
                                switchLanguage === "th"
                                  ? highlight.date_th
                                  : highlight.date_en
                              }}
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-card>
            </div>

            <v-layout
              class="justify-space-around custom-margin"
              style="margin-left: -17px"
            >
              <v-flex class="xs12">
                <v-divider style="border: 0.5px solid #C4C4C4;"></v-divider>
              </v-flex>
            </v-layout>

            <!-- Facebook feed -->
            <!-- <v-layout pt-12 class="justify-center">
              <v-flex class="flex-center" style=" max-width: 500px;">
                <div
                  class="fb-page"
                  data-href="https://www.facebook.com/CONNECTBYCEA/"
                  data-tabs="timeline"
                  :data-width="$vuetify.breakpoint.smAndUp ? '500' : ''"
                  :data-height="$vuetify.breakpoint.mdAndUp ? '400' : '500'"
                  data-small-header=""
                  data-adapt-container-width="true"
                  data-hide-cover="false"
                  data-show-facepile="false"
                  data-lazy="false"
                >
                  <blockquote
                    cite="https://www.facebook.com/CONNECTBYCEA/"
                    class="fb-xfbml-parse-ignore"
                  >
                    <a href="https://www.facebook.com/CONNECTBYCEA/"
                      >TCDC CONNECT</a
                    >
                  </blockquote>
                </div>
              </v-flex>
            </v-layout> -->

            <v-layout pt-12 class="justify-center">
              <v-flex class="flex-center" style=" max-width: 500px;">
                <iframe
                  :src="
                    'https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCONNECTBYCEA%2F&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=806762203217212'
                  "
                  :width="$vuetify.breakpoint.smAndUp ? '500' : ''"
                  :height="$vuetify.breakpoint.mdAndUp ? '400' : '500'"
                  style="border:none;overflow:hidden"
                  scrolling="no"
                  frameborder="0"
                  allowfullscreen="true"
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                ></iframe>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout class="justify-space-around my-12 px-6">
      <v-flex class="xs12">
        <v-divider style="border: 0.5px solid #C4C4C4;"></v-divider>
      </v-flex>
    </v-layout>

    <!-- Top Rank -->
    <v-layout class="justify-center mb-12" style="background-color: #F8F8F8;">
      <v-flex>
        <!-- Top Rank Desktop -->
        <v-layout
          mt-6
          mb-2
          class="justify-space-between  "
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-flex class="xs3 mx-4 d-flex justify-center align-center">
            <v-layout>
              <!-- icon star -->
              <v-flex shrink class="d-flex justify-center mr-2">
                <v-icon style="font-size: 6rem" color="#FFCD18">star</v-icon>
              </v-flex>

              <!-- title top rank  -->
              <v-flex shrink class="d-flex justify-center align-center">
                <v-layout class="column">
                  <v-flex
                    shrink
                    class="font-weight-bold"
                    style="font-size: 40px"
                  >
                    <span class="mr-3">Top</span><span>Rank</span>
                  </v-flex>
                  <v-flex class="flex-start mt-n2" style="font-size: 18px">
                    {{ $t("toprank-home") }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex
            class="xs3 d-flex justify-end align-center"
            v-for="(item, i) in top_ranks"
            :key="i"
          >
            <v-layout
              class="justify-end"
              style="cursor:pointer;"
              @click="goToDesigner(item)"
            >
              <v-flex class="shrink mr-2">
                <v-img
                  width="80"
                  height="80"
                  :src="
                    item.profile && item.profile.mem_info
                      ? checkImageTopRank(item.profile.mem_info, 'avatar')
                      : require('../../assets/user_profile.png')
                  "
                  style="border-radius: 50%;"
                />
              </v-flex>
              <v-flex class="ml-3 xs6 d-flex align-center">
                <div>
                  <div style="font-size: 18px">อันดับที่ {{ i + 1 }}</div>
                  <div style="color: #EF3E2D;font-size: 16px" class="one-line">
                    {{ checkName(item.profile) }}
                  </div>
                  <div style="font-size: 14px;">
                    {{ item.sum_view ? item.sum_view : 0 }} view
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Top Rank Mobile -->
        <v-layout mt-6 class="" v-else>
          <v-flex class="">
            <v-layout class="justify-center mb-8">
              <!-- icon star -->
              <v-flex shrink class="d-flex justify-center">
                <v-icon style="font-size: 4rem" color="#FFCD18">star</v-icon>
              </v-flex>

              <!-- title top rank  -->
              <v-flex shrink class="d-flex justify-center align-center">
                <v-layout class="column">
                  <v-flex
                    shrink
                    class="font-weight-bold"
                    style="font-size: 40px"
                  >
                    Top Rank
                  </v-flex>
                  <v-flex class="flex-start mt-n2 font-weight-bold">
                    {{ $t("toprank-home") }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout class="justify-center column">
              <v-flex
                class="shrink d-flex justify-center align-center mb-6"
                v-for="(item, i) in top_ranks"
                :key="i"
              >
                <v-layout
                  class="justify-center"
                  style="cursor:pointer;"
                  @click="goToDesigner(item)"
                >
                  <v-flex v-show="$vuetify.breakpoint.sm" class="xs2"></v-flex>
                  <v-flex class="shrink mr-2 flex-end">
                    <v-img
                      width="80"
                      height="80"
                      :src="
                        item.profile && item.profile.mem_info
                          ? checkImageTopRank(item.profile.mem_info, 'avatar')
                          : require('../../assets/user_profile.png')
                      "
                      style="border-radius: 50%;"
                    />
                  </v-flex>
                  <v-flex class="ml-6 xs6 d-flex align-center">
                    <div>
                      <div style="font-size: 18px">อันดับที่ {{ i + 1 }}</div>
                      <div
                        style="color: #EF3E2D;font-size: 16px"
                        class="one-line"
                      >
                        {{ checkName(item.profile) }}
                      </div>
                      <div style="font-size: 14px;">
                        {{ item.sum_view ? item.sum_view : 0 }} view
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import CardContent from "../../components/card_content/CardContent";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { domain, imgPath } from "../../services/Constants";
import { mapState } from "vuex";

export default {
  name: "HomePage",
  components: {
    CardContent,
    Loading,
  },
  data: () => ({
    imgPath: imgPath,
    url: domain,
    isLoading: false,
    isLoadingHighlight: false,
    isLoadingTop: false,
    isLoadingNew: false,
    isLoadingMost: false,
    isLoadingCreator: false,
    fullPage: true,
    newPorts: [],
    mostView: [],
    creator: [],
    highlight: "",
    data_toprank: [],
    top_ranks: [],
    sort: "desc",
  }),
  computed: {
    ...mapState({
      user: (state) => {
        return state.auth.users;
      },
      access_token: (state) => {
        return state.auth.access_token;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
      feeds: (state) => {
        return state.Common.feeds;
      },
    }),
  },
  created() {
    if (this.access_token) {
      this.getProfileUser();
    }
    this.getNewPortfolio();
    this.getMostViewPortfolio();
    this.getCreatorPortfolio();
    this.getCollectionoHighlight();
    this.getTopRank();

    this.$store.dispatch("portfolio/clearActiveMenuCate", 1);
  },
  methods: {
    onClickMoreCollection() {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 2);
      this.$store.dispatch("Collection/clearActiveMenuCreator", { id: 15 });
      this.$router.push("/creator");
      // this.$store.dispatch("Collection/clearActiveMenuCreator");
      // this.$router.push("/creator");
    },
    onclickCategory(item) {
      this.$router.push(
        `/portfolio-category/${this.switchLanguage === "th" ? "รวม" : "All"}`
      );

      // let data = {
      //   id: item.id,
      //   page: 1,
      // };
      // this.isLoading = true;
      // this.$store
      //   .dispatch("portfolio/getPortfolioByIdCategory", data)
      //   .then((res) => {
      //     this.isLoading = false;
      //     this.$router.push(`/portfolio-category/${item.name_th}`);
      //   });
    },
    getProfileUser() {
      // this.isLoading = true;
      this.$store
        .dispatch("profile/onGetProfileInfo", this.user.profile_id)
        .then((res) => {
          // this.isLoading = false;
        });
    },
    viewPortDetail(port) {
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
        path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    goToDesigner(item) {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 2);
      this.$router.push({
        path: `/profile/${
          item.profile.mem_info && item.profile.mem_info.domain_name
            ? item.profile.mem_info.domain_name
            : item.profile.profile_id
        }`,
      });
    },
    getNewPortfolio() {
      this.isLoadingNew = true;
      // return this.$store.dispatch('portfolio/getNewPortfolio').then(res => {
      this.$store
        .dispatch("portfolio/getNewPortfolio")
        .then((res) => {
          this.newPorts = res.data;
          setTimeout(() => {
            this.isLoadingNew = false;
          }, 1500);
        })
        .catch((e) => {
          console.log(e);
          this.isLoadingNew = false;
        });
    },
    getCreatorPortfolio() {
      this.isLoadingCreator = true;
      this.$store
        .dispatch("Collection/getCreatorPortfolio")
        .then((res) => {
          this.creator = res;
          setTimeout(() => {
            this.isLoadingCreator = false;
          }, 1500);
        })
        .catch((e) => {
          console.log(e);
          this.isLoadingCreator = false;
        });
    },
    getCollectionPortfolio(collection) {
      this.$store.dispatch("portfolio/clearActiveMenuCate", 2);
      this.$router.push({
        path: "sub-curated",
        query: {
          id: collection.id,
          collection_id: collection.collection_id,
          collection_name: collection.collection_name_th,
        },
      });
      // this.$store
      //   .dispatch("Collection/onGetCollectionById", id)
      //   .then((res) => {
      //     this.$router.push({
      //       path: "sub-curated",
      //       query: { collection_id: res.collection_id, collection_name: name },
      //     });
      //   })
      //   .catch((e) => {});
    },
    getCollectionoHighlight() {
      this.isLoadingHighlight = true;
      this.$store
        .dispatch("Collection/getCollectionoHighlight")
        .then((res) => {
          this.highlight = res;
          setTimeout(() => {
            this.isLoadingHighlight = false;
          }, 1000);
        })
        .catch((e) => {
          console.log(e);
          this.isLoadingHighlight = false;
        });
    },
    getTopRank() {
      this.isLoadingTop = true;
      this.top_ranks = [];
      this.$store
        .dispatch("portfolio/getToprankHomepage", this.sort)
        .then((res) => {
          this.data_toprank = res;
          for (var i = 0; i < 3; i++) {
            this.top_ranks.push(res[i]);
          }
          setTimeout(() => {
            this.isLoadingTop = false;
          }, 1000);
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    checkImage(val) {
      if (val) {
        if (val.avatar) {
          return val.avatar;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    checkImageTopRank(val, type) {
      if (val) {
        switch (type) {
          case "avatar":
            if (val.avatar) {
              return this.url + this.imgPath + "images_profile/" + val.avatar;
            } else {
              if (this.image_profile_facebook) {
                return this.image_profile_facebook;
              } else {
                return require("../../assets/user_profile.png");
              }
            }
            break;
          case "cover_url":
            return val.cover_url
              ? this.url +
                  this.imgPath +
                  "images_profile_cover/" +
                  val.cover_url
              : require("../../assets/cover.png");
            break;
        }
      } else {
        return require("../../assets/user_profile.png");
      }
    },
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th;
          // return val.name_th.length > 20 ? val.name_th.slice(0, 15)+' . . . . ' : val.name_th
        } else {
          return val.name_th + " " + val.last_th;
          // return val.name_th +' '+ (val.last_th.length > 25 ? val.last_th.slice(0, 20)+' . . . . ' : val.last_th);
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en;
          // return val.name_en.length > 20 ? val.name_en.slice(0, 15)+' . . . . ' : val.name_en
        } else {
          return val.name_en + " " + val.last_en;
          // return val.name_en +' '+ (val.last_en.length > 25 ? val.last_en.slice(0, 20)+' . . . . ' : val.last_en);
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
    ckeckLenghtName(text, val) {
      if (text === "project_title") {
        if (val) {
          if (val.length > 25) {
            return val.slice(0, 20) + " . . . .";
          } else {
            return val;
          }
        }
        return "";
      }
      if (text === "project_brief") {
        if (val) {
          if (val.length > 50) {
            return val.slice(0, 45) + " . . . .";
          } else {
            return val;
          }
        }
        return "";
      }
    },
    getMostViewPortfolio() {
      this.isLoadingMost = true;
      this.$store
        .dispatch("portfolio/getMostViewPortfolio")
        .then((res) => {
          this.mostView = res;
          setTimeout(() => {
            this.isLoadingMost = false;
          }, 1500);
        })
        .catch((e) => {
          console.log(e);
          this.isLoadingMost = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-img-fb {
  background-color: rgba(255, 102, 0, 0.693);
}
.img-column {
  border-radius: 5px;
}
</style>

<style>
.fb-comments,
.fb-comments iframe[style],
.fb-comments span {
  width: 100% !important;
}
.iframe-fb-container {
  /* text-align: center;
  width: 400px;
  height: 700px;
  display: inline-block; */
}

.iframe-fb {
  /* width: 400px;
  height: 700px;
  overflow: hidden; */
}

@media only screen and (max-width: 1920px) {
  .custom-margin {
    margin-top: 38px;
  }
}
@media only screen and (max-width: 1600px) {
  .custom-margin {
    margin-top: 41px;
  }
}
@media only screen and (min-width: 2560px) {
  .custom-margin {
    margin-top: 39px;
  }
}
@media only screen and (max-width: 1024px) {
  .custom-margin {
    margin-top: 26px;
  }
}
@media only screen and (max-width: 1366px) {
  .custom-margin {
    margin-top: 33px;
  }
}
@media only screen and (max-width: 1280px) {
  .custom-margin {
    margin-top: 19px;
  }
}
</style>
